if (!customElements.get("card-swatches")) {
  customElements.define(
    "card-swatches",
    class CardSwatches extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.swatches = this.querySelectorAll("[data-swatch]");
        this.cardWrapper = this.closest(".card-wrapper");

        this.swatches.forEach((swatch) => {
          swatch.addEventListener("click", this.onSwatchClick.bind(this));
        });

        if (this.querySelector("[data-swatch-media-json]")) {
          this.mediaArray = JSON.parse(this.querySelector("[data-swatch-media-json]").innerHTML);
        }
      }

      onSwatchClick(e) {
        e.preventDefault();
        this.switchPreviewImage(e.currentTarget.dataset.swatch);
        this.setActiveSwatch(e.currentTarget);
      }

      setActiveSwatch(swatchEl) {
        this.querySelector("button[aria-current]").removeAttribute("aria-current");
        swatchEl.setAttribute("aria-current", "true");
      }

      switchPreviewImage(swatch) {
        if (!this.mediaArray) return;
        const imageSrc = this.mediaArray.filter((mediaObject) => {
          return mediaObject.swatch == swatch;
        })[0].image;
        if (!imageSrc) return;
        const targetMedia = this.cardWrapper.querySelector(".media img:first-child");
        targetMedia.src = imageSrc;
        targetMedia.srcset = `${imageSrc}&width=500 500w`;
      }
    }
  );
}
